import React, { useState } from 'react'
import styles from './Header.module.scss'
const Header = () => {
    const [isOpenMobileNav, setIsOpenMobileNav] = useState(false)

    const handleCloseMobileNav = () => {
        setIsOpenMobileNav(false)
    }
    const handleOpenMobileNav = () => {
        setIsOpenMobileNav(true)
    }


    return (
        <header className={styles.header}>
            <div className={styles.mobileMenu}>
                <button className={styles.moobileMenuButton} onClick={handleOpenMobileNav}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff">
                        <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" />
                    </svg>
                </button>
                <div className={`${styles.mobileNav} ${isOpenMobileNav ? styles.open : ""}`}>
                    <div className={styles.headerMenu}>
                        <span className={styles.mobileLogoIcon}><img src='img/logo.png' /></span>
                        <span className={styles.mobileLogoText}>
                            Vision Aparts
                        </span>
                        <button className={styles.close} onClick={handleCloseMobileNav}>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px">
                                <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
                            </svg>
                        </button>
                    </div>
                    <nav className={styles.mobileList}>
                        <a href="#services">Услуги</a>
                        <a href="#gallery">Галерея</a>
                        <a href="#process">Процесс работы</a>
                        <a className={styles.contacts} href="#process">Контакты</a>
                        <a className={styles.btnPrimary} href="#process">Заказать</a>
                    </nav>
                </div>
            </div>
            <div className={styles.logo}>
                <span className={styles.logoIcon}><img src='img/logo.png' /></span>
                <span className={styles.logoText}>
                    Vision Aparts
                </span>
            </div>
            <nav className={styles.nav}>
                <a href="#services">Услуги</a>
                <a href="#gallery">Галерея</a>
                <a href="#process">Процесс работы</a>
            </nav>
            <div className={styles.headerActions}>
                <button className={styles.btnWhite}>Контакты</button>
                <button className={styles.btnSecondary}>Заказать</button>
            </div>
        </header>
    )
}

export default Header